// extracted by mini-css-extract-plugin
export var button = "NavToggleButton-module--button--1IHBi";
export var isX = "NavToggleButton-module--isX--3aaIN";
export var fadeIn = "NavToggleButton-module--fadeIn--DqUyH";
export var slideIn = "NavToggleButton-module--slideIn--2b4qd";
export var bgGradient = "NavToggleButton-module--bgGradient--Gs6MA";
export var borderColorStep = "NavToggleButton-module--borderColorStep--2v40B";